import { render, staticRenderFns } from "./TitleAssembly.vue?vue&type=template&id=3b51c4c8&scoped=true"
import script from "./TitleAssembly.vue?vue&type=script&lang=js"
export * from "./TitleAssembly.vue?vue&type=script&lang=js"
import style0 from "./TitleAssembly.vue?vue&type=style&index=0&id=3b51c4c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b51c4c8",
  null
  
)

export default component.exports